import { pluralize } from 'humanize-plus'

// based on `oxford` from humanize-plus
const Oxford = ({ items, limit, limitStr, conjunction = 'and' }) => {
  const numItems = items.length
  if (numItems < 2) return <span>{items[0]}</span>
  if (numItems === 2)
    return (
      <span>
        {items[0]} {conjunction} {items[1]}
      </span>
    )

  if (!!limit && numItems > limit) {
    const delta = numItems - limit
    limitStr = !!limitStr ? limitStr : `, ${conjunction} ${delta} ${pluralize(delta, 'other')}`
  } else {
    limitStr = (
      <span>
        , {conjunction} {items[numItems - 1]}
      </span>
    )
  }

  const sliceSize = !!limit && numItems > limit ? limit : -1

  return (
    <span>
      {items.slice(1, sliceSize).reduce(
        (oxfordArr, displayValue) => {
          return oxfordArr.concat([', ', displayValue])
        },
        [items[0]]
      )}
      {limitStr}
    </span>
  )
}

export default Oxford



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Oxford/index.js